import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import styles from './Header.module.css';

const Header: React.FC = () => {
  const location = useLocation();
  const isAboutPage = location.pathname === '/about';

  return (
    <header className={styles.header}>
      <div className={styles['header-content']}>
        <div className={styles['title-wrapper']}>
          <Link to="/" className={styles['title-link']}>
            <h1 className={styles['header-title']}>Marathi Proverbs</h1>
          </Link>
          <p className={styles['header-subtitle']}>Compiled by Sindhu Dokras</p>
        </div>
        <nav className={styles.nav}>
          <Link
            to="/"
            className={`${styles.navLink} ${!isAboutPage ? styles.active : ''}`}
            aria-current={!isAboutPage ? 'page' : undefined}
          >
            Proverbs
          </Link>
          <Link
            to="/about"
            className={`${styles.navLink} ${isAboutPage ? styles.active : ''}`}
            aria-current={isAboutPage ? 'page' : undefined}
          >
            About
          </Link>
        </nav>
      </div>
    </header>
  );
};

export default Header;
